document.addEventListener('DOMContentLoaded', () => {
  /**
   * ============================================================
   * Product Size Details
   * Horizon Theme
   * ============================================================
   */


  /* ------------------------------------------------------------
   * 1. Standard Size Data
   * ------------------------------------------------------------ */

  const SIZE_DETAILS = {
    us0: {cm: { b: '83', w: '65', h: '91', len: '150' },in: { b: '32 ½', w: '25 ½', h: '35 ¾', len: '59' },},
    us2: {cm: { b: '83', w: '65', h: '91', len: '150' },in: { b: '32 ½', w: '25 ½', h: '35 ¾', len: '59' },},
    us4: {cm: { b: '85', w: '68', h: '93', len: '150' },in: { b: '33 ½', w: '26 ½', h: '36 ¾', len: '59' },},
    us6: {cm: { b: '88', w: '70', h: '96', len: '152' },in: { b: '34 ½', w: '27 ½', h: '37 ¾', len: '60' },},
    us8: {cm: { b: '90', w: '72', h: '98', len: '152' },in: { b: '35 ½', w: '28 ½', h: '38 ¾', len: '60' },},
    us10: {cm: { b: '93', w: '75', h: '101', len: '152' },in: { b: '36 ½', w: '29 ½', h: '39 ¾', len: '60' },},
    us12: {cm: { b: '97', w: '79', h: '106', len: '152' },in: { b: '38', w: '31', h: '41 ¾', len: '60' },},
    us14: {cm: { b: '100', w: '83', h: '109', len: '155' },in: { b: '39 ½', w: '32 ½', h: '42 ¾', len: '61' },},
    us16: {cm: { b: '104', w: '86', h: '114', len: '155' },in: { b: '41', w: '34', h: '44 ¾', len: '61' },},
    us16w: {cm: { b: '104', w: '86', h: '114', len: '155' },in: { b: '41', w: '34', h: '44 ¾', len: '61' },},
    us18w: {cm: { b: '114', w: '98', h: '121', len: '155' },in: { b: '45', w: '38 ½', h: '47 ½', len: '61' },},
    us20w: {cm: { b: '119', w: '104', h: '126', len: '158' },in: { b: '47', w: '40 ¾', h: '49 ½', len: '62' },},
    us22w: {cm: { b: '124', w: '109', h: '131', len: '158' },in: { b: '49', w: '43', h: '51 ½', len: '62' },},
  };


  /* ------------------------------------------------------------
   * 2. Main Elements
   * ------------------------------------------------------------ */

  const detailBox = document.getElementById('product-sizedetai-info');

  if (!detailBox) {
    console.warn(
      '[Product Size] #product-sizedetai-info was not found.'
    );
    return;
  }


  /*
   * Prevent duplicate initialization.
   */
  if (detailBox.dataset.sizeInitialized === 'true') {
    return;
  }

  detailBox.dataset.sizeInitialized = 'true';


  /*
   * Find the product section that belongs to this Size block.
   */
  const productRoot =
    detailBox.closest('product-information') ||
    detailBox.closest('featured-product-information') ||
    detailBox.closest('.product-information') ||
    document;


  /* ------------------------------------------------------------
   * 3. Find Add To Cart Form
   * ------------------------------------------------------------ */

  const productForm =
    productRoot.querySelector(
      'product-form-component form[data-type="add-to-cart-form"]'
    ) ||
    productRoot.querySelector(
      'product-form-component form[action*="/cart/add"]'
    ) ||
    productRoot.querySelector(
      'form[data-type="add-to-cart-form"]'
    ) ||
    productRoot.querySelector(
      'form[action*="/cart/add"]'
    );


  /*
   * Custom Size inputs live outside the product form.
   * We therefore connect them using the HTML "form" attribute.
   */
  if (productForm && !productForm.id) {
    productForm.id = `hb-product-form-${Date.now()}`;
  }


  const productFormId = productForm?.id || '';


  if (!productFormId) {
    console.warn(
      '[Product Size] Add to Cart form was not found. ' +
      'Custom Size properties may not be submitted.'
    );
  }


  /* ------------------------------------------------------------
   * 4. Custom Size Markup
   * ------------------------------------------------------------ */

  function createCustomSizeForm() {
    const existingWrapper = productRoot.querySelector(
      '#t4s-product-custom-size-wrapper'
    );

    if (existingWrapper) {
      return existingWrapper;
    }


    const formAttribute = productFormId
      ? `form="${productFormId}"`
      : '';


    /*
     * Optional:
     * Custom Liquid can provide:
     *
     * data-custom-size-image="{{ 'custom-size.png' | asset_url }}"
     *
     * Fallback keeps compatibility with your current theme.
     */
    const customSizeImage =
      detailBox.dataset.customSizeImage ||
      '/cdn/shop/t/2/assets/custom-size.png?v2';


    const html = `
      <div
        id="t4s-product-custom-size-wrapper"
        class="hb-custom-size-wrapper"
        hidden
      >
        <div class="hb-custom-size-box">

          <p class="hb-custom-size-intro">
            Looking for the perfect fit? At no extra cost, our tailors
            will use your exact measurements to create a made-to-order
            dress just for you.
          </p>

          <div class="hb-custom-size-layout">

            <div class="hb-custom-size-left">

              <div class="hb-unit-toggle">

                <span class="hb-unit-label hb-unit-label-left">
                  IN
                </span>

                <label
                  class="hb-switch"
                  aria-label="Measurement unit"
                >
                  <input
                    type="checkbox"
                    id="hb-unit-toggle-input"
                  >

                  <span class="hb-slider"></span>
                </label>

                <span class="hb-unit-label hb-unit-label-right">
                  CM
                </span>

                <input
                  type="hidden"
                  id="hb-unit-hidden"
                  name="properties[Unit]"
                  value="inch"
                  ${formAttribute}
                  disabled
                >

              </div>


              <div class="hb-custom-grid">

                <div class="hb-field">

                  <div class="hb-field-label-row">
                    <label for="customsizebust">
                      Bust
                    </label>
                  </div>

                  <input
                    id="customsizebust"
                    class="hb-input"
                    data-field="bust"
                    type="number"
                    step="0.1"
                    min="0"
                    inputmode="decimal"
                    name="properties[Bust]"
                    placeholder="e.g. 34 inch"
                    ${formAttribute}
                    disabled
                  >

                </div>


                <div class="hb-field">

                  <div class="hb-field-label-row">
                    <label for="customsizewaist">
                      Waist
                    </label>
                  </div>

                  <input
                    id="customsizewaist"
                    class="hb-input"
                    data-field="waist"
                    type="number"
                    step="0.1"
                    min="0"
                    inputmode="decimal"
                    name="properties[Waist]"
                    placeholder="e.g. 28 inch"
                    ${formAttribute}
                    disabled
                  >

                </div>


                <div class="hb-field">

                  <div class="hb-field-label-row">
                    <label for="customsizehip">
                      Hips
                    </label>
                  </div>

                  <input
                    id="customsizehip"
                    class="hb-input"
                    data-field="hips"
                    type="number"
                    step="0.1"
                    min="0"
                    inputmode="decimal"
                    name="properties[Hips]"
                    placeholder="e.g. 38 inch"
                    ${formAttribute}
                    disabled
                  >

                </div>


                <div class="hb-field">

                  <div class="hb-field-label-row">
                    <label for="customsizehtf">
                      Hollow to Floor
                    </label>
                  </div>

                  <input
                    id="customsizehtf"
                    class="hb-input"
                    data-field="hollow"
                    type="number"
                    step="0.1"
                    min="0"
                    inputmode="decimal"
                    name="properties[Hollow to Floor]"
                    placeholder="e.g. 60 inch"
                    ${formAttribute}
                    disabled
                  >

                </div>

              </div>


              <p class="hb-custom-note">
                * Please provide accurate measurements. Our tailors will
                craft the dress based on the values you enter.
              </p>

            </div>


            <div class="hb-custom-size-right">

              <img
                src="${customSizeImage}"
                alt="How to measure bust, waist, hips and hollow to floor"
                class="hb-figure-img"
                loading="lazy"
              >

            </div>

          </div>

        </div>
      </div>
    `;


    detailBox.insertAdjacentHTML('afterend', html);


    return productRoot.querySelector(
      '#t4s-product-custom-size-wrapper'
    );
  }


  const customSizeWrapper = createCustomSizeForm();


  if (!customSizeWrapper) {
    console.warn(
      '[Product Size] Custom Size wrapper could not be created.'
    );
    return;
  }


  /* ------------------------------------------------------------
   * 5. Custom Size Elements
   * ------------------------------------------------------------ */

  const unitToggle = customSizeWrapper.querySelector(
    '#hb-unit-toggle-input'
  );

  const unitInput = customSizeWrapper.querySelector(
    '#hb-unit-hidden'
  );

  const bustInput = customSizeWrapper.querySelector(
    '#customsizebust'
  );

  const waistInput = customSizeWrapper.querySelector(
    '#customsizewaist'
  );

  const hipsInput = customSizeWrapper.querySelector(
    '#customsizehip'
  );

  const hollowInput = customSizeWrapper.querySelector(
    '#customsizehtf'
  );


  const measurementInputs = [
    bustInput,
    waistInput,
    hipsInput,
    hollowInput,
  ].filter(Boolean);


  const customPropertyInputs = [
    unitInput,
    ...measurementInputs,
  ].filter(Boolean);


  /* ------------------------------------------------------------
   * 6. Helpers
   * ------------------------------------------------------------ */

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }


  function normalizeSize(value) {
    let size = normalizeText(value);


    /*
     * Support:
     * 2   -> us2
     * 16w -> us16w
     */
    if (
      !size.startsWith('us') &&
      /^\d+w?$/.test(size)
    ) {
      size = `us${size}`;
    }


    return size;
  }


  function isCustomSize(value) {
    const size = normalizeText(value);

    return (
      size === 'custom size' ||
      size === 'custom'
    );
  }


  function getFieldsetLabel(fieldset) {
    if (!fieldset) {
      return '';
    }

    const legend = fieldset.querySelector('legend');

    return normalizeText(
      legend?.textContent || ''
    );
  }


  function isSizeFieldset(fieldset) {
    const label = getFieldsetLabel(fieldset);

    if (
      label === 'size' ||
      label.startsWith('size ')
    ) {
      return true;
    }


    /*
     * Fallback for themes where legend structure changes.
     */
    const firstInput = fieldset?.querySelector('input');

    const inputName = normalizeText(
      firstInput?.name || ''
    );

    return inputName.startsWith('size');
  }


  function getVariantPicker() {
    return productRoot.querySelector(
      'variant-picker'
    );
  }


  function getSizeFieldset() {
    const variantPicker = getVariantPicker();

    if (!variantPicker) {
      return null;
    }


    const fieldsets = variantPicker.querySelectorAll(
      'fieldset'
    );


    for (const fieldset of fieldsets) {
      if (isSizeFieldset(fieldset)) {
        return fieldset;
      }
    }


    return null;
  }


  /* ------------------------------------------------------------
   * 7. Unit Handling
   * ------------------------------------------------------------ */

  function updateUnitUI() {
    const useCentimeters = Boolean(
      unitToggle?.checked
    );


    const unit = useCentimeters
      ? 'cm'
      : 'inch';


    if (unitInput) {
      unitInput.value = unit;
    }


    const placeholders = useCentimeters
      ? {
          bust: 'e.g. 88 cm',
          waist: 'e.g. 70 cm',
          hips: 'e.g. 96 cm',
          hollow: 'e.g. 152 cm',
        }
      : {
          bust: 'e.g. 34 inch',
          waist: 'e.g. 28 inch',
          hips: 'e.g. 38 inch',
          hollow: 'e.g. 60 inch',
        };


    measurementInputs.forEach((input) => {
      const field = input.dataset.field;

      if (field && placeholders[field]) {
        input.placeholder = placeholders[field];
      }
    });
  }


  unitToggle?.addEventListener(
    'change',
    updateUnitUI
  );


  /* ------------------------------------------------------------
   * 8. Custom Size State
   * ------------------------------------------------------------ */

  function clearCustomSizeValues() {
    measurementInputs.forEach((input) => {
      input.value = '';
    });
  }


  function setCustomSizeEnabled(enabled) {
    customPropertyInputs.forEach((input) => {
      input.disabled = !enabled;
    });


    measurementInputs.forEach((input) => {
      input.required = enabled;
    });
  }


  function showCustomSizeForm() {
    detailBox.innerHTML = '';
    detailBox.hidden = true;
    detailBox.style.display = 'none';


    /*
     * Start every new Custom Size selection with
     * empty measurements.
     */
    clearCustomSizeValues();


    customSizeWrapper.hidden = false;
    customSizeWrapper.style.display = 'block';


    setCustomSizeEnabled(true);
    updateUnitUI();
  }


  function hideCustomSizeForm() {
    customSizeWrapper.hidden = true;
    customSizeWrapper.style.display = 'none';


    setCustomSizeEnabled(false);
    clearCustomSizeValues();
  }


  /* ------------------------------------------------------------
   * 9. Standard Size Table
   * ------------------------------------------------------------ */

  function buildSizeTable(sizeKey, detail) {
    return `
      <div class="hb-size-detail">
        <table class="hb-size-detail-table">
          <thead>
            <tr>
              <th class="hb-size-name">${sizeKey.toUpperCase()}</th>
              <th>Bust</th>
              <th>Waist</th>
              <th>Hips</th>
              <th class="hb-size-length">Hollow to Floor</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">IN</th>
              <td>${detail.in.b}</td>
              <td>${detail.in.w}</td>
              <td>${detail.in.h}</td>
              <td>${detail.in.len}</td>
            </tr>
            <tr>
              <th scope="row">CM</th>
              <td>${detail.cm.b}</td>
              <td>${detail.cm.w}</td>
              <td>${detail.cm.h}</td>
              <td>${detail.cm.len}</td>
            </tr>
          </tbody>
        </table>
      </div>
    `;
  }


  function showStandardSize(sizeKey) {
    const detail = SIZE_DETAILS[sizeKey];


    hideCustomSizeForm();


    if (!detail) {
      detailBox.innerHTML = '';
      detailBox.hidden = true;
      detailBox.style.display = 'none';

      console.warn(
        `[Product Size] No size data found for "${sizeKey}".`
      );

      return;
    }


    detailBox.innerHTML = buildSizeTable(
      sizeKey,
      detail
    );


    detailBox.hidden = false;
    detailBox.style.display = 'block';
  }


  /* ------------------------------------------------------------
   * 10. Handle Selected Size
   * ------------------------------------------------------------ */

  function handleSizeChange(value) {
    if (isCustomSize(value)) {
      showCustomSizeForm();
      return;
    }


    const sizeKey = normalizeSize(value);

    showStandardSize(sizeKey);
  }


  /* ------------------------------------------------------------
   * 11. Horizon Variant Change Listener
   * ------------------------------------------------------------
   *
   * Event delegation is used intentionally.
   *
   * Horizon can morph / replace the contents of
   * <variant-picker> after a variant change.
   * Binding directly to the original radio buttons could
   * therefore stop working.
   * ------------------------------------------------------------ */

  document.addEventListener('change', (event) => {
    const target = event.target;


    if (
      !(
        target instanceof HTMLInputElement ||
        target instanceof HTMLSelectElement
      )
    ) {
      return;
    }


    const variantPicker = target.closest(
      'variant-picker'
    );


    if (!variantPicker) {
      return;
    }


    /*
     * Ignore other products, Quick Add,
     * Featured Product, etc.
     */
    if (
      productRoot !== document &&
      !productRoot.contains(variantPicker)
    ) {
      return;
    }


    /*
     * Radio / Button option
     */
    if (target instanceof HTMLInputElement) {
      const fieldset = target.closest(
        'fieldset'
      );


      if (!isSizeFieldset(fieldset)) {
        return;
      }


      handleSizeChange(target.value);

      return;
    }


    /*
     * Select / Dropdown option
     */
    if (target instanceof HTMLSelectElement) {
      const fieldset = target.closest(
        'fieldset'
      );


      if (
        fieldset &&
        isSizeFieldset(fieldset)
      ) {
        handleSizeChange(target.value);
        return;
      }


      /*
       * Dropdown fallback.
       */
      const selectName = normalizeText(
        target.name
      );


      if (selectName.includes('size')) {
        handleSizeChange(target.value);
      }
    }
  });


  /* ------------------------------------------------------------
   * 12. Initial Selected Size
   * ------------------------------------------------------------ */

  function loadInitialSize() {
    const sizeFieldset = getSizeFieldset();


    if (!sizeFieldset) {
      console.warn(
        '[Product Size] Size fieldset was not found.'
      );

      return;
    }


    /*
     * Horizon Button / Radio style
     */
    const checkedInput = sizeFieldset.querySelector(
      'input:checked'
    );


    if (checkedInput) {
      handleSizeChange(
        checkedInput.value
      );

      return;
    }


    /*
     * Dropdown style
     */
    const select = sizeFieldset.querySelector(
      'select'
    );


    if (select?.value) {
      handleSizeChange(
        select.value
      );
    }
  }


  /* ------------------------------------------------------------
   * 13. Initialize
   * ------------------------------------------------------------ */

  hideCustomSizeForm();
  updateUnitUI();
  loadInitialSize();
});